import AdvancedController from "./advanced-controller"
import { slideIn, slideOut } from "../animations/animation-slide";
import { fadeIn, fadeOut } from "../animations/animation-fade";
import { Breakpoints } from "../utils/breakpoints";

const NAV_TOGGLE_BREAKPOINT = 'sm'


export default class AccordionItemController extends AdvancedController {

  static targets = ['item', 'body'];

  static values = {
    isOpen: Boolean,
    currentBreakpoint: String
  }

  connect() {
    super.connect(...arguments);
    this.breakpoints = new Breakpoints();
    const accordionEl = this.getController('accordion').typeValue == 'horizontal' ? this.element.closest('.block__horizontal-accordion') : this.element.closest('.block__accordion');
    this._accordionController = accordionEl['accordion'];
    this._accordionController.messageItemConnected(this)
  }

  resize() {
    const newBreakpoint = this.breakpoints.getCurrentBreakpoint();
    if (this.currentBreakpoint !== newBreakpoint) {
      const oldBreakpoint = this.currentBreakpoint;
      this.currentBreakpoint = newBreakpoint;

      this._handleState()
    }

  }

  onToggle() {
    this.isOpenValue = !this.isOpenValue
    this._handleState();
  }

  messageClose() {
    this.isOpenValue = false
    this._handleState();
  }

  messageOpen() {
    this.isOpenValue = true
    this._handleState();
  }

  _handleState() {
    if (this.isOpenValue) {
      if (this._accordionController.typeValue == 'horizontal' && this.breakpoints.breakpointUp(NAV_TOGGLE_BREAKPOINT)) {
        fadeIn(this.bodyTarget);

      } else {
        slideIn(this.bodyTarget)
      }

      this._accordionController.messageAddActive(this)
      this.itemTarget.classList.add('-active');
    } else {

      if (this._accordionController.typeValue == 'horizontal' && this.breakpoints.breakpointUp(NAV_TOGGLE_BREAKPOINT)) {
        fadeOut(this.bodyTarget);

      } else {
        slideOut(this.bodyTarget);
      }
      this.itemTarget.classList.remove('-active');
    }

  }

}
